import React, { useEffect } from "react";
import {
	Drawer,
	DrawerOverlay,
	DrawerContent,
	DrawerHeader,
	DrawerBody,
	DrawerCloseButton,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { setCollapsed } from "newui/features/AppMenu";

interface FullDrawContainerProps {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	children: React.ReactNode;
	size?: "full" | "xl" | "lg" | "md";
}

export const FullDrawContainer: React.FC<FullDrawContainerProps> = ({
	isOpen,
	onClose,
	title,
	children,
	size = "full",
}) => {
	const dispatch = useDispatch();

	useEffect(() => {
		if (isOpen && size === "full") {
			dispatch(setCollapsed(true));
		}
	}, [isOpen, size, dispatch]);

	return (
		<Drawer isOpen={isOpen} onClose={onClose} placement="right" size={size}>
			<DrawerOverlay />
			<DrawerContent>
				<DrawerCloseButton />
				<DrawerHeader borderBottomWidth="1px" fontSize="lg">
					{title}
				</DrawerHeader>
				<DrawerBody>
					<div className="mx-auto max-w-[1400px] pb-8 pt-4">
						{children}
					</div>
				</DrawerBody>
			</DrawerContent>
		</Drawer>
	);
};
